<template>
	<transition name="modal" v-cloak>
		<div class="modal-mask" @keyup="handleKeypress" >
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header"></slot>
                    <div
                      v-if="hasClose"
                      v-event-track:closeButtonClicked="{ click_source: eventTrackingSource, button_name: 'x'}"
                      class="close"
                      @click="$emit('close')"
                    >
                    </div>
                </div>

                <div class="modal-body">
                    <slot></slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
		</div>
	</transition>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';

export default {
    props: {
        hasClose: {
            type: Boolean,
            required: false,
            default: false
        },
        // eventTrackingSource is used to specify the click_source property for event tracking
        eventTrackingSource: {
            type: String,
            required: false,
            default: '',
        },
    },
    data: () => ({
        scrollingContainers: [],
        scrollY: 0,
    }),
    mounted() {
        window.addEventListener('keyup', this.handleKeypress);
        this.scrollingContainers = [
            document.querySelector('body'),
        ];
        this.updateScrollingContainers(true);
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeypress);
        this.updateScrollingContainers(false);
    },

    methods: {
        handleKeypress(event) {
            if (event.key === 'Escape') {
                eventTracker(
                    analyticsEvents.closeButtonClicked, {
                        click_source: this.eventTrackingSource,
                        button_name: '[pressed escape]',
                    },
                );
                this.$emit('close');
            }
        },
        updateScrollingContainers(removeScrollbar) {
            this.scrollingContainers.forEach(e => {
                if (!e || !e.classList) return;
                if (removeScrollbar) {
                    e.classList.add('overflow-hidden', 'w-full');
                    this.scrollY = window.scrollY;
                    document.body.style.top = `-${this.scrollY}px`;
                    document.body.style.position = 'fixed';
                    document.body.style.width = '100%';
                } else {
                    e.classList.remove('overflow-hidden', 'w-full');
                    document.body.style.position = '';
                    document.body.style.top = '';
                    window.scrollTo(0, this.scrollY);
                }
            });
        }
    }
}
</script>

<style scoped>
.modal-container .close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.modal-container .close::before,
.modal-container .close::after {
  content: '';
  width: 20px;
  height: 2px;
  background: #999999;
  position: absolute;
  display: block;
  top: 10px;
}
.modal-container .close::before {
  transform: rotate(-45deg);
}

.modal-container .close::after {
  transform: rotate(45deg);
}
@screen md {
    .modal-container .close {
        right: 20px;
        top: 20px;
    }
}
</style>